import { MARQUEE_ITEMS } from "../site/content";

export default function Marquee({ dark = false }) {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div
      className={`overflow-hidden border-y py-5 sm:py-7 select-none ${
        dark ? "border-cream/10 bg-teal-dark" : "border-line bg-sand/60"
      }`}
      aria-hidden="true"
      data-testid="editorial-marquee"
    >
      <div className="flex w-max animate-marquee items-center gap-8 pr-8">
        {items.map((item, i) => (
          <span key={i} className="flex items-center gap-8">
            <span
              className={`whitespace-nowrap font-serif text-3xl sm:text-5xl font-medium italic ${
                dark ? "text-cream/15" : "text-teal/20"
              }`}
            >
              {item}
            </span>
            <span
              className={`h-2 w-2 rotate-45 ${dark ? "bg-sand/30" : "bg-teal/25"}`}
            />
          </span>
        ))}
      </div>
    </div>
  );
}
